import { combineReducers } from "redux";
import obterCamadas from "./actions/obterCamadas";
import selecionarCamada from "./actions/selecionarCamada";

export default combineReducers({
  obterCamadas,
  selecionarCamada
});
